export const getMembershipCandidatePath = (clubId?: string) =>
  `/club/${clubId}/manage-membership`;

export const getMembershipAddNewCandidatePath = (clubId?: string) =>
  `/club/${clubId}/manage-membership-add`;

export const getIdentifyClubCandidatePath = (clubId?: string) =>
  `/club/${clubId}/manage-membership/candidate-details/identify-candidate`;

export const getCandidateDetailsPath = (clubId?: string) =>
  `/club/${clubId}/manage-membership/candidate-details`;

export const getCovertCandidateToMemberPath = (
  clubId?: string,
  individualId?: string
) => `/club/${clubId}/manage-membership/convert-candidate/${individualId}`;

export const getDistrictMembershipCandidatePath = (riDistrictId?: string) =>
  `/district/${riDistrictId}/manage-membership`;

export const getDistrictMemberPath = (riDistrictId?: string) =>
  `/district/${riDistrictId}/manage-membership/candidate-details`;
